import React from 'react';
import UsersTable from '../../components/UsersTable';

const User = () => {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4">
      <h1 className="mb-4 text-2xl font-semibold text-gray-900">用户管理</h1>
      <UsersTable />
    </div>
  );
};

export default User;
